import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { BitrateResult } from '../../../models/app/precall/bitrate-result';
import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { ToKbpsPipe } from '../../../shared/pipes/to-kbps.pipe';

@Component({
  selector: 'app-bitrate-info-test',
  imports: [NgTemplateOutlet, ToKbpsPipe, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './bitrate-info-test.component.html',
})
export class BitrateInfoTestComponent {
  type = input.required<'audio' | 'video'>();
  result = input.required<BitrateResult>();
}
